import { WorkspacePlacementMetricCard } from '@/components/workspace/WorkspaceCampaignPlacementCells';
import {
  evaluatedConditionLines,
  formatConditionColumnText,
  formatEvaluationSummary,
  type ConditionMetricMeta,
} from '@/utils/automationExecutionChange';
import {
  CAMPAIGN_PLACEMENT_LINES,
  isMetricSnapshot,
  placementCardMetrics,
} from '@/utils/placementExecutionMetrics';
import type { AutomationExecutionEvaluation } from '@/api/automationApi';

export function PlacementConditionCell({
  evaluation,
  evaluationSummary,
  catalog,
}: {
  evaluation: AutomationExecutionEvaluation | null | undefined;
  evaluationSummary?: string | null;
  catalog: ConditionMetricMeta[];
}) {
  const lines = evaluatedConditionLines(evaluation, catalog);
  if (!lines) {
    return (
      <span>
        {formatConditionColumnText(evaluationSummary || formatEvaluationSummary(evaluation))}
      </span>
    );
  }
  return (
    <div className="flex min-w-[16rem] flex-col gap-1.5">
      {lines.map((line) => (
        <div key={line.id} className="text-xs leading-snug">
          {line.showGroupLabel ? (
            <div className="mb-0.5 font-medium text-foreground-muted">{line.groupLabel}</div>
          ) : null}
          <div className="flex flex-wrap items-baseline gap-x-1.5 gap-y-0.5">
            <span className="text-foreground">{line.metricLabel}</span>
            {line.actualText ? (
              <span className="font-mono tabular-nums text-foreground">{line.actualText}</span>
            ) : null}
            {line.comparisonText ? (
              <span className="text-foreground-muted">{line.comparisonText}</span>
            ) : null}
            {line.relativeText ? (
              <span className="text-foreground-muted">{line.relativeText}</span>
            ) : null}
          </div>
        </div>
      ))}
    </div>
  );
}

export function PlacementMetricsCell({
  current,
  previous,
}: {
  current: unknown;
  previous: unknown;
}) {
  if (!isMetricSnapshot(current)) {
    return <span className="text-foreground-muted">—</span>;
  }
  const prev =
    isMetricSnapshot(previous) && Object.keys(previous).length > 0 ? previous : null;
  return (
    <div className="flex flex-wrap gap-2">
      {CAMPAIGN_PLACEMENT_LINES.map((line) => (
        <WorkspacePlacementMetricCard
          key={line.id}
          title={line.label}
          current={placementCardMetrics(current, line.id)}
          previous={prev ? placementCardMetrics(prev, line.id) : null}
          compareEnabled={prev != null}
          contentClassName="z-[90]"
        />
      ))}
    </div>
  );
}
